module.exports = __webpack_public_path__ + "cebcde461b8c340e8e2bf87d124b409f.jpg";